import { useState, useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { ChevronDown, ChevronRight } from 'lucide-react'
import { nav, type NavSection } from '../nav'

function SidebarSection({ section }: { section: NavSection }) {
  const location = useLocation()
  const isActive = section.items.some(i => location.pathname === i.path)
  const [open, setOpen] = useState(isActive)

  useEffect(() => {
    if (isActive) setOpen(true)
  }, [isActive])

  return (
    <div className="mb-1">
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center gap-2 px-3 py-1.5 rounded text-left hover:bg-slate-100 transition-colors group"
      >
        <span className="text-sm">{section.icon}</span>
        <span className="flex-1 text-[12.5px] font-semibold text-slate-700 tracking-tight">{section.title}</span>
        {open
          ? <ChevronDown size={13} className="text-slate-400 shrink-0" />
          : <ChevronRight size={13} className="text-slate-400 shrink-0" />}
      </button>

      {open && (
        <div className="ml-5 mt-0.5 space-y-px border-l border-slate-200 pl-3">
          {section.items.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `block px-2 py-1 text-[13px] rounded-r transition-colors leading-snug ${
                  isActive
                    ? 'text-blue-600 font-medium bg-blue-50 border-l-2 border-blue-500 -ml-3 pl-[calc(0.5rem+2px)]'
                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
                }`
              }
            >
              {item.title}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  )
}

export function Sidebar() {
  return (
    <aside className="w-[260px] shrink-0 border-r border-slate-200 bg-[#FAFAFA] flex flex-col fixed top-12 bottom-0 left-0 overflow-y-auto z-10">
      <nav className="flex-1 py-4 px-3 space-y-px">
        {nav.map(section => (
          <SidebarSection key={section.title} section={section} />
        ))}
      </nav>

      <div className="px-4 py-3 border-t border-slate-200 shrink-0">
        <p className="text-[11px] text-slate-400">Rabbit Platform · v1.0</p>
      </div>
    </aside>
  )
}
